// import { useMutation } from 'react-query';
import { useMutation } from '@tanstack/react-query';
import { useApiPost } from 'mf_core/query';
// export type Iscreated = {};
export function useSetFcmToken() {
  const apiPost = useApiPost();
  return useMutation({
    mutationFn: (body: any) => {
      return apiPost(
        `/account-management/v1/notifications/set-fcm-token`,
        body,
        undefined
      );
    },
  });
}
